import { withContext } from '@hotjar/webapp/tracking/common';
import { paymentMethodAPI } from '@hotjar/webapp/domains/billing/paymentMethod';
import { authenticatePaymentMethod as authenticatePaymentMethodWith3DS } from '@hotjar/checkout';
import { mapOwnedAccountDtoToModel } from '@hotjar/account';
import type { OwnedAccountDTO } from '@hotjar/account';
import type { SubscriptionChangePriceSummary, AccountOverrides } from './subscription';
import { subscriptionAPI } from './subscription';

/**
 * Get and authenticate (if needed) the existing payment
 *
 * @param account The account to authenticate for.
 * @param shouldAuthenticate Whether authentication is needed
 * @param accountOverrides List of overrides for preview endpoint
 * @param trackOrigin Identifier of the feature that invokes authentication
 * @returns Returns the payment method with nonce if it was authenticated
 */
// FIXME: Please fix this. You may refer to CFE-266 for more details.
// eslint-disable-next-line func-params-args/func-params
export function getPreviewedAuthenticatedPaymentMethod(
  // TODO: this should be OwnedAccount model
  account: OwnedAccountDTO,
  // eslint-disable-next-line @typescript-eslint/default-param-last
  shouldAuthenticate = true,
  accountOverrides: AccountOverrides | undefined,
  trackOrigin: string,
): Promise<{ nonce: string | null }> {
  return withContext({ origin: trackOrigin }, () =>
    paymentMethodAPI.get(account?.id as number).then(
      (paymentMethod) => {
        if (shouldAuthenticate) {
          // Authenticate flow, preview the costs, if they differ
          // then authenticate the payment method
          return Promise.all([
            subscriptionAPI.preview(account, [], account.billing_cycle, undefined),
            subscriptionAPI.preview(account, [], account.billing_cycle, accountOverrides),
          ]).then(
            ([current, updated]: [
              SubscriptionChangePriceSummary,
              SubscriptionChangePriceSummary,
            ]) =>
              current.future.totalWithTax.eq(updated.future.totalWithTax)
                ? paymentMethod
                : authenticatePaymentMethodWith3DS(
                    // technically account should be OwnedAccount, but converting it here to avoid a bigger refactor
                    mapOwnedAccountDtoToModel(account),
                    paymentMethod,
                    updated.future.totalWithTax,
                  ),
          );
        }
        // Otherwise pass through the payment method
        return paymentMethod;
      },
      // no payment method, just pass an empty nonce
      () => ({ nonce: null }),
    ),
  );
}
